<div id="modalSxkm" tabindex="-1" role="dialog" aria-labelledby="modalCotizacion" aria-hidden="true">
  <div class="">

    <div class="">
      <div id="myCarousel" class="carousel slide" style="max-width: 768px;">
        <!-- Carousel indicators -->
        <ol class="carousel-indicators">
          <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
          <li data-target="#myCarousel" data-slide-to="1"></li>
          <li data-target="#myCarousel" data-slide-to="2"></li>
          <li data-target="#myCarousel" data-slide-to="3"></li>
          <li data-target="#myCarousel" data-slide-to="4"></li>
        </ol>
        <!-- Carousel items -->
        <div class="carousel-inner">
          <div class="active item">
            <!-- MODAL ITEM 1 -->
            <div class="modal-welcome">
              <div class="modal-welcome-header">
                <div class="modal-welcome-header-logo">
                  <img src="/assets/img/sura-logo-sxkm-blanco.svg" alt="logo sxkm blanco" />
                </div>
                <img class="close" src="/assets/img/sura-icon-close-blanco.svg" alt="icon"
                  (click)="activeModal.close('Close click')" />
              </div>
              <div class="modal-welcome-content">
                <div class="modal-welcome-content__img">
                  <img src="/assets/img/sura-modal-woman.png" alt="WOMAN SXKM" />
                </div>
                <div class="modal-welcome-content__desc">
                  <h2>¡Conoce la nueva vista de Seguro x KM!</h2>
                  <p>
                    Ahora tendrás una nueva forma de ver la información de tu
                    seguro
                  </p>
                  <a href="#myCarousel" class="button-border-white" data-slide="next">CONTINUAR</a>
                  <a (click)="activeModal.close('Close click')" data-dismiss="modal" class="close">CERRAR</a>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <!-- MODAL ITEM 2 -->
            <div class="modal-welcome">
              <div class="modal-welcome-header">
                <div class="modal-welcome-header-logo">
                  <img src="/assets/img/sura-logo-sxkm-blanco.svg" alt="logo sxkm blanco" />
                </div>
                <img class="close" src="/assets/img/sura-icon-close-blanco.svg" alt="icon"
                  (click)="activeModal.close('Close click')" />
              </div>
              <div class="modal-welcome-content">
                <div class="modal-welcome-content__img">
                  <img src="/assets/img/sura-modal-woman.png" alt="WOMAN SXKM" />
                </div>
                <div class="modal-welcome-content__desc">
                  <img src="/assets/img/sura-icon-modal-car-repair.svg" alt="sura icon modal escudo" />
                  <h3>1. Un completo resumen</h3>
                  <p>
                    En <strong>“Mi Seguro”</strong> podrás encontrar el valor
                    de gasto al día, kilómetros recorridos, última ubicación,
                    asistencias, detalles de tu auto y de tu póliza en un
                    mismo lugar.
                  </p>
                  <a href="#myCarousel" class="button-border-white" data-slide="next">CONTINUAR</a>
                  <a (click)="activeModal.close('Close click')" class="close">CERRAR</a>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <!-- MODAL ITEM 3 -->
            <div class="modal-welcome">
              <!-- modal header -->
              <div class="modal-welcome-header">
                <div class="modal-welcome-header-logo">
                  <img src="/assets/img/sura-logo-sxkm-blanco.svg" alt="logo sxkm blanco" />
                </div>
                <img class="close" src="/assets/img/sura-icon-close-blanco.svg" alt="icon"
                  (click)="activeModal.close('Close click')" />
              </div>
              <!-- modal content -->
              <div class="modal-welcome-content">
                <div class="modal-welcome-content__img">
                  <img src="/assets/img/sura-modal-woman.png" alt="WOMAN SXKM" />
                </div>
                <div class="modal-welcome-content__desc">
                  <img src="/assets/img/sura-icon-modal-rutas.svg" alt="sura icon modal escudo" />
                  <h3>2. Más detalles de tus viajes</h3>
                  <p>
                    En <strong>“Mis viajes”</strong> verás el la conducción,
                    distancias recorridas y gasto de cada viaje del día y
                    también de días anteriores donde hayas tenido viajes.
                  </p>
                  <a href="#myCarousel" class="button-border-white" data-slide="next">CONTINUAR</a>
                  <a class="close" (click)="activeModal.close('Close click')">CERRAR</a>
                </div>
              </div>
            </div>
          </div>

          <div class="item">
            <!-- MODAL ITEM 4 -->
            <div class="modal-welcome">
              <div class="modal-welcome-header">
                <div class="modal-welcome-header-logo">
                  <img src="/assets/img/sura-logo-sxkm-blanco.svg" alt="logo sxkm blanco" />
                </div>
                <img class="close" src="/assets/img/sura-icon-close-blanco.svg" alt="icon"
                  (click)="activeModal.close('Close click')" />
              </div>
              <div class="modal-welcome-content">
                <div class="modal-welcome-content__img">
                  <img src="/assets/img/sura-modal-woman.png" alt="WOMAN SXKM" />
                </div>
                <div class="modal-welcome-content__desc">
                  <img src="/assets/img/sura-icon-modal-volante.svg" alt="sura icon modal escudo" />
                  <h3>3. Sabrás mejor cómo manejas</h3>
                  <p>
                    En <strong>“Mi Seguro”</strong> podrás encontrar el valor
                    de gasto al día, kilómetros recorridos, última ubicación,
                    asistencias, detalles de tu auto y de tu póliza en un
                    mismo lugar.
                  </p>
                  <a href="#myCarousel" class="button-border-white" data-slide="next">CONTINUAR</a>
                  <a class="close" (click)="activeModal.close('Close click')">CERRAR</a>
                </div>
              </div>
            </div>
          </div>

          <div class="item">
            <!-- MODAL ITEM 5 -->
            <div class="modal-welcome">
              <div class="modal-welcome-header">
                <div class="modal-welcome-header-logo">
                  <img src="/assets/img/sura-logo-sxkm-blanco.svg" alt="logo sxkm blanco" />
                </div>
                <img class="close" src="/assets/img/sura-icon-close-blanco.svg" alt="icon"
                  (click)="activeModal.close('Close click')" />
              </div>
              <div class="modal-welcome-content">
                <div class="modal-welcome-content__img">
                  <img src="/assets/img/sura-modal-woman.png" alt="WOMAN SXKM" />
                </div>
                <div class="modal-welcome-content__desc">
                  <img src="/assets/img/sura-icon-modal-escudo.svg" alt="sura icon modal escudo" />
                  <h3>4. Tu auto también necesita atención</h3>
                  <p>
                    En <strong>“Mi auto”</strong>, recibirás alertas sobre la
                    salud de tu vehículo, como el estado de la bateria,
                    refrigerante, transmisión y otros, así realizas de manera
                    oportuna los ajustes que tu auto necesite y evitas
                    accidentes.
                  </p>
                  <a class="button button-border--white"
                    (click)="activeModal.close('Close click')">VER&nbsp;MI&nbsp;SEGURO&nbsp;X&nbsp;KM</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Carousel nav -->
        <a class="carousel-control left-flat" href="#myCarousel" data-slide="prev">&lsaquo;</a>
        <a class="carousel-control right-flat" href="#myCarousel" data-slide="next">&rsaquo;</a>
      </div>
    </div>
  </div>
</div>